import React from 'react';
import PropTypes from 'prop-types';
import UiKitButton from 'components/UiKit/Button';
import clipboardIcon from 'assets/clipboardIcon.png';
import AddRoundedIcon from '@material-ui/icons/AddRounded';

const noCompaniesOverlayDefaultPropOnClick = () => {};
const NoCompaniesOverlay = ({
  open = false,
  onClick = noCompaniesOverlayDefaultPropOnClick,
  memberRole
}) => {
  return (
    <>
      {open && (
        <div
          data-testid="property-overlay-modal"
          className="p-10 bg-white border rounded-none sm:rounded border-neutral"
        >
          <div className="flex flex-col justify-center">
            <div className="self-center">
              <img width="356" height="318" src={clipboardIcon} alt="" />
            </div>
            <div className="self-center mb-3">
              <p>
                We were unable to find any companies under this organization.
              </p>
            </div>
            <div className="self-center">
              {memberRole !== 'View Only' ? (
                <UiKitButton
                  icon={<AddRoundedIcon />}
                  onClick={onClick}
                  id="overlay-create-property-btn"
                  variant="primary"
                >
                  Create Company
                </UiKitButton>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

NoCompaniesOverlay.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  memberRole: PropTypes.string.isRequired
};

export default NoCompaniesOverlay;
